import React from 'react'
import { rem } from 'polished'
import ImageWithReservedSpace from 'components/Common/ImageWithReservedSpace'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'

const BnblPackageContainer = styled.div`
  display: grid;
  grid-template: auto / ${rem(96)} 1fr;
  gap: ${rem(16)};
`

const PackageDetails = styled.div`
  align-self: center;
`

interface Props {
  image: App.Image;
  packageName: string;
  roomTypeName: string;
}

export function BnblPackageImageAndName(props: Props) {
  const { image, packageName, roomTypeName } = props

  return (
    <BnblPackageContainer>
      <ImageWithReservedSpace
        id={image.id!}
        alt={image.title}
        mobileAspectRatio="1"
        mobileWidth="96px"
      />
      <PackageDetails>
        <BodyText weight="bold" variant="large">{packageName}</BodyText>
        <BodyText variant="large">{roomTypeName}</BodyText>
      </PackageDetails>
    </BnblPackageContainer>
  )
}
